import type { Permission } from '#/entity';
import { PermissionType } from '#/enum';

const isProduction = import.meta.env.APP_ENVIRONMENT === 'production';

export const DASHBOARD_PERMISSION: Permission = {
  id: '9100714781927703',
  parentId: '',
  label: 'sys.menu.dashboard',
  name: 'Dashboard',
  icon: 'local:ic-analysis',
  type: PermissionType.MENU,
  component: '/dashboard/analysis/index.tsx',
  route: 'dashboard',
  order: 1,
};

export const MANAGEMENT_PERMISSION: Permission = {
  id: '0901673425580518',
  parentId: '',
  label: 'sys.menu.management',
  name: 'Management',
  icon: 'local:ic-management',
  type: PermissionType.CATALOGUE,
  route: 'management',
  order: 2,
  children: [
    {
      id: '0157880245365435',
      parentId: '0901673425580518',
      label: 'sys.menu.admin_logs.index',
      name: 'Admin logs',
      type: PermissionType.MENU,
      route: 'admin_logs',
      component: '/management/admin_logs/index.tsx',
    },
    {
      id: '0157880245365434',
      parentId: '0901673425580518',
      label: 'sys.menu.admin_users.index',
      name: 'Admin',
      type: PermissionType.MENU,
      route: 'admin_users',
      component: '/management/admin_users/index.tsx',
    },
    {
      id: '4359580910369986',
      parentId: '0901673425580518',
      label: 'sys.menu.system.properties',
      name: 'Properties',
      type: PermissionType.MENU,
      route: 'properties',
      component: '/management/properties/index.tsx',
    },
    ...(!isProduction
      ? [
          {
            id: '0157880245365436',
            parentId: '0901673425580518',
            label: 'sys.menu.property_admins.index',
            name: 'Property Admins',
            type: PermissionType.MENU,
            route: 'property_admins',
            component: '/management/admin_users/index.tsx',
          },
        ]
      : []),
    {
      id: '0157880245365433',
      parentId: '0901673425580518',
      label: 'sys.menu.user.index',
      name: 'Users',
      type: PermissionType.MENU,
      route: 'users',
      component: '/management/users/index.tsx',
    },
    {
      id: '0157880245365432',
      parentId: '0901673425580518',
      label: 'sys.menu.user.detail',
      name: 'User Detail',
      type: PermissionType.MENU,
      route: 'users/:id',
      component: '/management/users/detail.tsx',
      hide: true,
    },
    {
      id: '4359580910369992',
      parentId: '0901673425580518',
      label: 'Devices',
      name: 'Devices',
      type: PermissionType.MENU,
      route: 'devices',
      component: '/management/device/index.tsx',
    },
    {
      id: '0157880245365432',
      parentId: '0901673425580518',
      label: 'sys.menu.device.detail',
      name: 'Device Detail',
      type: PermissionType.MENU,
      route: 'devices/:id',
      component: '/management/device/detail.tsx',
      hide: true,
    },
    {
      id: '4359580910369993',
      parentId: '0901673425580518',
      label: 'sys.menu.system.channel_categories',
      name: 'Channel Categories',
      type: PermissionType.MENU,
      route: 'channel_categories',
      component: '/management/channel_categories/index.tsx',
    },
    {
      id: '4359580910369990',
      parentId: '0901673425580518',
      label: 'sys.menu.system.channels',
      name: 'Channels',
      type: PermissionType.MENU,
      route: 'channels',
      component: '/management/channels/index.tsx',
    },
    {
      id: '0157880245365491',
      parentId: '0901673425580518',
      label: 'sys.menu.system.channel_detail',
      name: 'Channel Detail',
      type: PermissionType.MENU,
      route: 'channels/:id',
      component: '/management/channels/detail.tsx',
      hide: true,
    },
    {
      id: '4359580910369994',
      parentId: '0901673425580518',
      label: 'Movies',
      name: 'Movie',
      type: PermissionType.MENU,
      route: 'movies',
      component: '/management/movies/index.tsx',
    },
    {
      id: '4359580910369996',
      parentId: '0901673425580518',
      label: 'Series',
      name: 'series',
      type: PermissionType.MENU,
      route: 'series',
      component: '/management/series/index.tsx',
    },
    {
      id: '4359580910369998',
      parentId: '0901673425580518',
      label: 'sys.menu.system.series_detail',
      name: 'Series Detail',
      type: PermissionType.MENU,
      route: 'series/:id',
      component: '/management/series/detail.tsx',
      hide: true,
    },
    {
      id: '4359580910369999',
      parentId: '4359580910369998',
      label: 'sys.menu.system.seasons_detail',
      name: 'Seasons Detail',
      type: PermissionType.MENU,
      route: 'series/:id/seasons/:id',
      component: '/management/series/season-detail.tsx',
      hide: true,
    },
  ],
};

export const PERMISSION_LIST: Permission[] = [DASHBOARD_PERMISSION, MANAGEMENT_PERMISSION];
